import React, { useEffect } from 'react';

import { Box } from '@ublend-npm/aulaui-core';

import useBreakpoints from '@app/hooks/useBreakpoints';
import { useFlags } from 'launchdarkly-react-client-sdk';
import pushRoute from '@app/utils/routing';
import { useSelector } from 'react-redux';
import { getCurrentSpaceId } from '@core/selectors/space';
import InviteParticipants from './InviteParticipants';

interface InviteParticipantsScreenProps {
  params: {
    conversationId: string;
  };
}

const InviteParticipantsScreen = ({
  params,
}: InviteParticipantsScreenProps) => {
  const { lg } = useBreakpoints();
  const { conversationId } = params;
  const spaceId = useSelector(getCurrentSpaceId);

  // This screen should redirect to messages if the screen is large
  useEffect(() => {
    if (lg && conversationId) {
      pushRoute(`dashboard/${spaceId}/messages/${conversationId}`);
    }
  }, [lg, conversationId, spaceId]);

  const { webAppFtResponsiveMessages202506 } = useFlags();
  if (!webAppFtResponsiveMessages202506) {
    pushRoute('/dashboard');
  }

  const handleClose = () => {
    if (conversationId) {
      pushRoute(`dashboard/${spaceId}/messages/${conversationId}`);
    } else {
      pushRoute(`dashboard/${spaceId}/messages`);
    }
  };

  return (
    <Box sx={{ margin: 2 }}>
      <InviteParticipants
        onClose={handleClose}
        conversationId={conversationId}
      />
    </Box>
  );
};

export default InviteParticipantsScreen;
